<div style="background: #000000; justify-content: center; width:420px; height:480px; margin-left: -14%">
  <div style=" text-align: center; height: 60px; justify-content: center; align-content:center;">
    <img src="../../assets/nav-menu/PMLogo4.png" alt="Responsive image" style="width: 150px;" />
  </div>

  <form [formGroup]="Contact_usForm" class="form" (submit)="submit_form()" style="background: #000000; font-family: 'Glacial Indifference'; height: 300px;"autocomplete="off">
    <div style="text-align:center;">
      <div style="font-size:30px;color:white;">Contact Us</div>
      <div style="font-size: 10px;color: white;">Got a question? We'd love to hear from you. <br /> and we'll respond as soon as possible.</div>
    </div>

    <div class="form-group">
      <h6>Name</h6>
      <input autofocus="" class="form-group__control ng-pristine ng-invalid ng-touched" formControlName="username" style="height: 25px;" required type="text">
      <div class="invalid-feedback" *ngIf="Contact_usForm.controls.username.errors?.['required']">Username is required</div>
    </div>
    <div class="form-group">
      <h6>Email address</h6>
      <input autofocus="" class="form-group__control ng-pristine ng-invalid ng-touched" formControlName="email" style="height: 25px;" required type="text">
      <div class="invalid-feedback" *ngIf="Contact_usForm.controls.email.errors?.['required']">
        Email is required
      </div>
      <div class="invalid-feedback" *ngIf="Contact_usForm.controls.email?.errors?.pattern">
        Enter a valid Email eg(example@gmail.com)
      </div>
    </div>
    <div class="form-group">
      <h6>Message</h6>
      <input autofocus="" class="form-group__control ng-pristine ng-invalid ng-touched" formControlName="message" required type="text" style="height:60px;">
      <div class="invalid-feedback" *ngIf="Contact_usForm.controls.message.errors?.['required']">
        Message is required
      </div>
    </div>

    <div class="center ">
      <button type="submit" class="btn btn-primary" [disabled]="!Contact_usForm.valid || busy">Submit</button>
    </div>

  </form>

</div>
